import groupBy from "lodash/groupBy";
import { useSuggester } from "../../../../../core/suggest/useSuggester";
import { EditorCursorPopup } from "../../../../popup";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { RecordSuggesterMenu } from "../RecordSuggesterMenu/RecordSuggesterMenu";
import { isPromise } from "../../../../../core/object-utils";
export const RecordSuggesterRaw = ({ view, suggesterCallbacksRegistry, mentionService, }) => {
    const [suggester, setSuggester] = useState(null);
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const query = suggester === null || suggester === void 0 ? void 0 : suggester.queryText.partial;
        const result = mentionService.searchRecords(query);
        if (isPromise(result)) {
            setLoading(true);
            // eslint-disable-next-line promise/catch-or-return
            result
                .then((records) => setRecords(records))
                .catch((error) => console.error("Error fetching records", error))
                .finally(() => setLoading(false));
        }
        else {
            setRecords(result);
        }
    }, [mentionService, suggester]);
    const groupedOptions = useMemo(() => {
        const indexedOptions = records
            .sort((a, b) => a.application.name.localeCompare(b.application.name))
            .map((option, index) => ({
            index,
            ...option,
        }));
        return groupBy(indexedOptions, (option) => option.application.name);
    }, [records]);
    const handleEnter = useCallback((index) => {
        suggester.command(records[index]);
    }, [records, suggester]);
    const menuRef = useRef();
    const { visible, activeIndex } = useSuggester({
        menuRef,
        suggesterCallbacksRegistry,
        commandsLength: records.length,
        onEnter: handleEnter,
        onParamsChange: useCallback((suggesterParams) => setSuggester(suggesterParams), []),
    });
    useEffect(() => {
        var _a;
        (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-item-index="${activeIndex}"]`).scrollIntoView({ block: "nearest" });
    }, [activeIndex]);
    if (!visible || !suggester) {
        return null;
    }
    return (React.createElement(EditorCursorPopup, { view: view, from: suggester.range.from, to: suggester.range.to, placement: "bottom-start", flipEnabled: true, preventOverFlowEnabled: false },
        React.createElement(RecordSuggesterMenu, { ref: menuRef, activeIndex: activeIndex, groupedOptions: groupedOptions, loading: loading, onClick: handleEnter })));
};
export const RecordSuggester = memo(RecordSuggesterRaw);
